module.exports = __webpack_public_path__ + "media/images/cafetière-0e5f7caa409989336f50c34940c568d9.svg";